module.exports = __webpack_public_path__ + "img/globe.ba67d50f.svg";